import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Router, Refresh } from "@mui/icons-material";
const TableHeader = ({ title, loading, onRefresh, lastFetchedAt, disabled }) => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    justifyContent="space-between"
    alignItems={{ sm: "center" }}
    gap={2}
    sx={{
      p: 3,
      color: "#fff",
      background: "linear-gradient(120deg,#1e293b,#0b4f6c)",
      borderRadius: "12px 12px 0 0",
    }}
  >
    <Stack direction="row" alignItems="center" gap={2}>
      <Box sx={{ p: 1.1, display: "flex", bgcolor: "#ffffff18", borderRadius: 2 }}>
        <Router />
      </Box>
      <Box>
        <Typography variant="h5" color="inherit" fontWeight={700}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "#d5e4ed", mt: 0.5 }}>
          Monitoreo de readers y antenas por grupo y comercio
        </Typography>
        <Typography variant="caption" sx={{ color: "#d5e4ed" }}>
          {loading
            ? "Consultando dispositivos…"
            : lastFetchedAt
            ? `Última consulta: ${new Date(lastFetchedAt).toLocaleString("es-CO", {
                timeZone: "America/Bogota",
              })}`
            : "Pendiente de consulta"}
        </Typography>
      </Box>
    </Stack>
    <Button
      variant="outlined"
      startIcon={<Refresh />}
      onClick={onRefresh}
      disabled={loading || disabled}
      sx={{
        alignSelf: { xs: "flex-start", sm: "center" },
        color: "#fff",
        borderColor: "#ffffff80",
        "&:hover": { borderColor: "#fff", bgcolor: "#ffffff12" },
      }}
    >
      {loading ? "Consultando…" : "Actualizar"}
    </Button>
  </Stack>
);
TableHeader.propTypes = {
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
  lastFetchedAt: PropTypes.string,
  disabled: PropTypes.bool,
};
export default React.memo(TableHeader);
